import React from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Globals } from "./constants";

import { Helmet } from "react-helmet";

class Games extends React.Component {
  constructor(props) {
    super(props);

    this.currentPageScroll = 0;
    this.currentGamePage = 1;

    this.state = {
      data: [],
      isLoading: true,
    };
    this.handleScroll = this.handleScroll.bind(this);
    let MSISDN = "";
    if (!localStorage.getItem("user")) {
      window.location.href = "/login";
    } else {
      console.log("new class", JSON.parse(localStorage.getItem("user")));
      MSISDN = JSON.parse(localStorage.getItem("user")).phone;
    }
    // this.nextPage = this.nextPage.bind(this);
  }

  nextPage = async () => {
    try {
      const URL = `https://cwscoring.cricwick.net/api/v4/games?page=${
        this.currentGamePage
      }&msisdn=${JSON.parse(localStorage.getItem("user")).phone}&app_name=${
        Globals.appName
      }`;
      let resp = await axios.get(URL);
      console.log(resp);
      if (resp.data.status === 1) {
        var lastState = this.state.data.more_games;
        var currentState = resp.data.data.more_games;
        var children = lastState.concat(currentState);
        resp.data.data.recent = this.state.data.recent;
        resp.data.data.top_picked = this.state.data.top_picked;
        resp.data.data.more_games = children;
        await this.setState({ data: resp.data.data, isLoading: false });
        console.log("ss", resp.data.data);
      }
    } catch (e) {
      console.log("Error fetching games", e.message);
    }
  };
  handleScroll(event) {
    let mainContent = document.getElementById("main-card");
    // console.log(  window.innerHeight+document.documentElement.scrollTop," = ",mainContent.scrollHeight);
    if (mainContent) {
      if (
        window.innerHeight + document.documentElement.scrollTop >=
        mainContent.scrollHeight
      ) {
        if (
          this.currentPageScroll < mainContent.scrollHeight &&
          !this.state.isLoading
        ) {
          this.currentPageScroll = mainContent.scrollHeight;
          this.currentGamePage++;
          this.nextPage();
          console.log("end");
        }
      }
    }
  }

  componentDidMount() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    this.getGames();
    window.addEventListener("scroll", this.handleScroll, true);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  getGames = async () => {
    try {
      const URL = `https://cwscoring.cricwick.net/api/v4/games?page=1&msisdn=${
        JSON.parse(localStorage.getItem("user")).phone
      }&app_name=${Globals.appName}`;
      console.log("ghalti ", URL);
      let resp = await axios.get(URL);
      console.log(resp);
      if (resp.data.status === 1) {
        await this.setState({ data: resp.data.data, isLoading: false });
        console.log("ss", this.state.data);
      }
    } catch (e) {
      console.log("Error fetching games", e.message);
    }
  };

  render() {
    let maxTOShow = 2;
    let maxTOShow2 = 2;
    if (!this.state.isLoading) {
      if (this.state.data.recent.length >= 4) {
        maxTOShow = 4;
      } else if (this.state.data.recent.length == 0) {
        maxTOShow = 2;
      } else if (this.state.data.recent.length == 1) {
        maxTOShow = 2;
      } else {
        maxTOShow = this.state.data.recent.length;
      }

      if (this.state.data.top_picked.length >= 4) {
        maxTOShow2 = 4;
      } else if (this.state.data.top_picked.length == 0) {
        maxTOShow2 = 2;
      } else if (this.state.data.top_picked.length == 1) {
        maxTOShow2 = 2;
      } else {
        maxTOShow2 = this.state.data.top_picked.length;
      }
    }

    var settings = {
      arrows: false,
      dots: false,
      infinite: true,
      speed: 200,
      swipeToSlide: true,
      slidesToShow: maxTOShow,

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: maxTOShow,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: maxTOShow - 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: maxTOShow - 1,
          },
        },
      ],
    };

    var settings1 = {
      arrows: false,
      dots: false,
      infinite: true,
      speed: 200,
      swipeToSlide: true,
      slidesToShow: maxTOShow2,

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: maxTOShow2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: maxTOShow2 - 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: maxTOShow2 - 1,
          },
        },
      ],
    };

    if (this.state.isLoading) {
      return (
        <div id="main-section">
          <div className="card">
            <div className="main-loader card min-height-80vh">
              <img width="64" height="64" src="/images/loader_v2.gif" alt="" />
            </div>
          </div>
        </div>
      );
    }
    return (
      <section id="main-section">
        <Helmet>
          <link
            rel="canonical"
            href={window.location.href.replace("www.", "")}
          />
        </Helmet>
        <div className="card" ref="all" id="main-card">
          <div className="row p-2">
            <p className="game-cat-title-text">Recently Played</p>
            <div style={{ width: "90%", margin: "auto" }}>
              <Slider {...settings}>
                {this.state.data.recent.map(function(item, i) {
                  return (
                    <div className="text-center">
                      {/* <Link to={`/games/${item.id}`}>  */}
                      <Link to={`/games/${item.id}`}>
                        <img
                          style={{ margin: "auto" }}
                          src={item.thumbnail}
                          width="96"
                          height="96"
                        />
                      </Link>
                      <p className="text-center game-name-text">
                        {" "}
                        {item.title}{" "}
                      </p>
                    </div>
                  );
                })}
              </Slider>
            </div>
          </div>

          {/* ToP PICKED*/}
          <div className="row p-2 mt-4">
            <h5 className="game-cat-title-text">Top Picks</h5>
            <div style={{ width: "90%", margin: "auto" }}>
              <Slider {...settings1}>
                {this.state.data.top_picked.map(function(item, i) {
                  return (
                    <div className="text-center ">
                      <Link to={`/games/${item.id}`}>
                        <img
                          className="img-fluid"
                          style={{ margin: "auto" }}
                          src={item.thumbnail}
                          width="90"
                          height="90"
                        />
                      </Link>

                      <p className="text-center game-name-text">
                        {" "}
                        {item.title}{" "}
                      </p>
                    </div>
                  );
                })}
              </Slider>
            </div>
          </div>

          {/* MORE GAMES*/}
          <div className="row p-2 mt-4">
            <h5 className="game-cat-title-text">More Games</h5>
            <div style={{ width: "90%", margin: "auto" }}>
              {/* <Slider {...settingsMoreGames}> */}
              {this.state.data.more_games.map(function(item, i) {
                return (
                  <div className="d-inline-block text-center more-games-thumbwidth">
                    {/* <Link to={`/games/${item.id}`}> */}
                    <Link to={`/games/${item.id}`}>
                      <img
                        className="img-fluid"
                        style={{ margin: "auto" }}
                        src={item.thumbnail}
                      />
                    </Link>
                    <p className="text-center text-truncate game-name-text">
                      {" "}
                      {item.title}{" "}
                    </p>
                    {/* </Link> */}
                  </div>
                );
              })}
              {/* </Slider> */}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Games;
